import React from 'react'

import { SIconSpan } from '../../../common/styles/Icons'

interface IIconProps {
    fill?: string
    size?: number
    title?: string
    id?: string
}

const AddIcon = ({ fill = 'currentColor', size = 14, title, id = 'info-icon' }: IIconProps): React.ReactElement => {
    return (
        <SIconSpan title={title} id={id} size={size}>
            <svg width="100%" height="100%" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_3971_11307)">
                    <path d="M20 10H12V2H10V10H2V12H10V20H12V12H20V10Z" fill={fill} />
                </g>
                <defs>
                    <clipPath id="clip0_3971_11307">
                        <rect width="18" height="18" fill={fill} transform="translate(2 2)" />
                    </clipPath>
                </defs>
            </svg>
        </SIconSpan>
    )
}

export default AddIcon
